import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Info extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        if (!content || content.length === 0) return <div />;

        return (
            <div className={styles.box}>
                <p className={styles.title}>网罗天下</p>
                <ul className="clearfix">
                    {content.map((item, index) => (
                        <li key={index} className={index < 4 ? styles.mg10 : ''}>
                            <a href={item.url} target="_blank" title={item.title}>
                                <img src={item.img} />
                                <p>{item.title}</p>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Info);
